import { formatPhoneNumberByBlocks } from './phone-number.utils';
import { CountryCode, CountryFormat } from './phone-number.types';

export const COUNTRY_FORMATS: Record<CountryCode, CountryFormat> = {
  US: {
    countryCallingCode: '1',
    formatter: (digits) => {
      const parts = digits.slice(0, 10);
      if (parts.length < 4) {
        return parts;
      }
      if (parts.length < 7) {
        return `(${parts.slice(0, 3)}) ${parts.slice(3)}`;
      }
      return `(${parts.slice(0, 3)}) ${parts.slice(3, 6)}-${parts.slice(6)}`;
    },
  },
  MX: {
    countryCallingCode: '52',
    formatter: (digits) => `+52 ${formatPhoneNumberByBlocks(digits.slice(0, 10), [3, 3, 4])}`,
  },
  UA: {
    countryCallingCode: '380',
    formatter: (digits) => `+380 ${formatPhoneNumberByBlocks(digits.slice(0, 10), [2, 3, 4])}`,
  },
  UNKNOWN: {
    countryCallingCode: '',
    formatter: (digits) => digits,
  },
};

export const CALLING_CODE_TO_COUNTRY_MAP = Object.entries(COUNTRY_FORMATS).reduce<Record<string, CountryCode>>(
  (acc, [country, data]) => {
    if (data.countryCallingCode) {
      acc[data.countryCallingCode] = country as CountryCode;
    }
    return acc;
  },
  {},
);
